module.exports = __webpack_public_path__ + "img/197.e4fa78f9.jpg";